import { useChangeCase } from '@vueuse/integrations/useChangeCase'

export function useSiteHandle() {
  const siteConfig = useSiteConfig()

  return useChangeCase(() => siteConfig.name ?? '', 'kebabCase')
}
